/* © 2022 Promethean. All Rights Reserved.
 *
 * Unauthorized copying of this file or any part of this file
 * via any medium is strictly prohibited.
 */
import React, { forwardRef } from 'react';
export var ArrowIcon = function ArrowIcon(direction) {
  return (
    /*#__PURE__*/
    // eslint-disable-next-line react/display-name
    forwardRef(function (props, ref) {
      return direction === 'left' ? /*#__PURE__*/React.createElement("span", {
        className: "icon-chevron-left-alt"
      }) : /*#__PURE__*/React.createElement("span", {
        className: "icon-chevron-right-alt"
      });
    })
  );
};